import { call, select } from 'redux-saga/effects';

import { moveToInsuranceProductsWithParams } from 'data-providers/insurance';
import * as InsuranceCalculationConstants from 'store/insuranceCalculation/constants';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

import * as InsuranceConstants from '../../constants';
import { CreateStage } from '../../helpers';

export const insuranceStageMoveToInsuranceProductsWithParams = new CreateStage({
  action: InsuranceConstants.ACTIONS.MOVE_TO_INSURANCE_PRODUCTS_WITH_PARAMS,
  handler: function* () {
    const applicationId = yield select(InsuranceCalculationSelectors.selectApplicationId);
    const {
      [InsuranceCalculationConstants.FIELDS.MIN_DRIVERS_AGE]: minDriversAge,
      [InsuranceCalculationConstants.FIELDS.MIN_DRIVERS_EXPERIENCE]: minDriversExperience,
      [InsuranceCalculationConstants.FIELDS.MULTIDRIVE]: multidrive,
    } = yield select(InsuranceCalculationSelectors.selectInsuranceCalculation);

    const request = { applicationId, parameters: { multidrive } };

    if (typeof minDriversAge === 'number') {
      request.parameters.minDriversAge = minDriversAge;
    }

    if (typeof minDriversExperience === 'number') {
      request.parameters.minDriversExperience = minDriversExperience;
    }

    yield call(moveToInsuranceProductsWithParams, request);
  },
  name: InsuranceConstants.STAGES_FIELDS.MOVE_TO_INSURANCE_PRODUCTS_WITH_PARAMS,
}).watcher;
